<template>
  <b-form @submit="onSubmit">
    <b-row>
      <b-col>
        <b-form-group
          :id="`input-group-question`"
          :label-for="`input-question`"
          :label="`Question ${form.id}`">
          <b-form-textarea
            :id="`input-question`"
            v-model="form.question"
            maxlength="125"
            type="text"
            placeholder="Exemple : Quel jour sommes-nous ?"
            required
          />
          <div class="text-right">{{
            `${questionLength}
               / 125 caractères restants` }}
          </div>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group
          :id="`input-group-answer`"
          :label-for="`input-answer`"
          label="Réponse attendue">
          <b-form-input
            :id="`input-answer`"
            v-model="form.answer"
            placeholder="Exemple : Lundi"
            type="text"
            required
          />
      </b-form-group></b-col>
      <b-col>
        <b-form-group
          :id="`input-group-false1`"
          :label-for="`index-false1`"
          label="Mauvaise réponse 1">
          <b-form-input
            :id="`index-false1`"
            v-model="form.false_1"
            type="text"
            placeholder="Exemple : Septembre"
            required
          />
      </b-form-group></b-col>
      <b-col>
        <b-form-group
          :id="`input-group-false2`"
          :label-for="`index-false2`"
          label="Mauvaise réponse 2">
          <b-form-input
            :id="`index-false2`"
            v-model="form.false_2"
            type="text"
            placeholder="Exemple : En 2021"
            required
          />
      </b-form-group></b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group
          :id="`input-group-explanation`"
          :label-for="`input-explanation`"
          label="Explication">

          <b-form-textarea
            :id="`input-explanation`"
            v-model="form.explanation"
            type="text"
            maxlength="550"
            placeholder="Exemple : Le premier jour du reste de ta vie. C'est un matin comme tous les autres. Un nouveau pari. Rechercher un peu de magie dans cette inertie morose."
            required
          />
          <div class="text-right">{{
            `${explanationLength}
               / 550 caractères restants` }}
          </div>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group
          label="Image">
          <b-form-file
            v-model="form.img"
            :state="Boolean(form.img)"
            placeholder="Choisissez un fichier ou déposez-le ici..."
            drop-placeholder="Déposez-le ici..."
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-alert
          show
          variant="info">
          Si vous ne choisissez pas de nouvelle image, l'ancienne sera conservée
        </b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div
          v-if="form.img"
          class="mt-3">
          Fichier sélectionné: {{ form.img ? form.img.name : '' }}
        </div>
      </b-col>
    </b-row>
    <b-row/>
    <b-row>
      <b-col class="text-center">
        <b-button
          :disabled="pending"
          type="submit"
          variant="primary">
          <span v-if="pending">
            <b-spinner
              small
              variant="light"/>
          </span>
          <span v-else>
            Enregistrer
          </span>
        </b-button>
      </b-col>
    </b-row>

  </b-form>
</template>

<script>
export default {
  name: 'FormQuiz',
  props: {
    question: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: {
        id: null,
        question: null,
        anwser: null,
        false_1: null,
        false_2: null,
        explanation: null,
        img: null,
      },
      pending: false,
    };
  },
  watch: {

  },
  mounted() {
    this.form.id = this.question.dmo_id;
    this.form.answer = this.question.dmo_data.answers.filter(r => r.result)[0].response;
    this.form.false_1 = this.question.dmo_data.answers.filter(r => !r.result)[0].response;
    this.form.false_2 = this.question.dmo_data.answers.filter(r => !r.result)[1].response;
    this.form.question = this.question.dmo_data.question;
    this.form.explanation = this.question.dmo_data.explanation;
  },
  computed: {
    explanationLength(){
      return this.form?.explanation?.length + (this.form?.explanation?.match(/\n\n/g) || [])?.length * 55;
    },
    questionLength() {
      return this.form?.question?.length;
    }
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.pending = true;
      if (this.form.img) {
        const formData = new FormData();
        formData.append('file', this.form.img);
        formData.append('id', this.form.id);
        formData.append('question', this.form.question);
        formData.append('answer', this.form.answer);
        formData.append('false_1', this.form.false_1);
        formData.append('false_2', this.form.false_2);
        formData.append('explanation', this.form.explanation);
        formData.append('quiz_id', this.question.dmo_data.id);
        formData.append('img', this.form.img);
        this.$store.dispatch('modules/updateQuestionWithImage', formData).then(() => {
          this.$emit('questionUpdated');
          this.pending = false;
        });
      } else {
        this.$store.dispatch('modules/updateQuestion', this.form).then(() => {
          this.$emit('questionUpdated');
          this.pending = false;
        });
      }
    },
  },
};
</script>

<!--suppress CssInvalidFunction -->
<style scoped>
.form_questions {
  padding: 10px;
  background-color: aliceblue;
  border-radius: 10px;
  border: 1px solid rgb(0 123 255 / 50%);
  margin: 10px 0;
}
</style>
